import React from 'react';
import { Box, CircularProgress, Typography, Backdrop } from '@mui/material';

interface Props {
  fullScreen?: boolean;
  message?: string;
}

const LoadingSpinner: React.FC<Props> = ({ fullScreen = false, message }) => {
  if (fullScreen) {
    return (
      <Backdrop
        open={true}
        sx={{
          zIndex: theme => theme.zIndex.drawer + 1,
          backgroundColor: 'rgba(255, 255, 255, 0.9)',
          backdropFilter: 'blur(4px)',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 2,
          }}
        >
          <CircularProgress
            size={48}
            sx={{
              color: 'primary.main',
              filter: 'drop-shadow(0 0 8px rgba(0, 104, 185, 0.3))',
            }}
          />
          {message && (
            <Typography
              variant="body1"
              color="text.secondary"
              className="animate-fadeIn"
              sx={{ mt: 2 }}
            >
              {message}
            </Typography>
          )}
        </Box>
      </Backdrop>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        p: 2,
        gap: 1,
      }}
    >
      <CircularProgress
        size={32}
        sx={{
          color: 'primary.main',
        }}
      />
      {message && (
        <Typography
          variant="body2"
          color="text.secondary"
          align="center"
        >
          {message}
        </Typography>
      )}
    </Box>
  );
};

export default LoadingSpinner;
